export const GET_POOL_REQUEST_INBOX_REQUEST = 'GET_POOL_REQUEST_INBOX_REQUEST';

export const getPoolRequestInboxRequest = () => ({
    type: GET_POOL_REQUEST_INBOX_REQUEST,
});
